import css from "./MetaIcons.module.scss";

const Date = () => (
	<svg className={css._} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<rect x="4" y="5" width="16" height="15" rx="2" ry="2" />
		<line x1="8" y1="3" x2="8" y2="7" />
		<line x1="16" y1="3" x2="16" y2="7" />
		<g>
			<circle cx="8" cy="11.5" r="0.55" />
			<circle cx="8" cy="16" r="0.55" />
			<circle cx="12" cy="11.5" r="0.55" />
			<circle cx="12" cy="16" r="0.55" />
			<circle cx="16" cy="11.5" r="0.55" />
			<circle cx="16" cy="16" r="0.55" />
		</g>
	</svg>
);
const Role = () => (
	<svg className={css._} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<circle cx="12" cy="5" r="3" />
		<line x1="12" y1="8" x2="12" y2="11.5" />
		<line x1="6" y1="11.5" x2="18" y2="11.5" />
		<line x1="6" y1="11.5" x2="6" y2="15" />
		<line x1="18" y1="11.5" x2="18" y2="15" />
		<circle cx="6" cy="18" r="3" />
		<circle cx="18" cy="18" r="3" />
	</svg>
);
const Tool = () => (
	<svg className={css._} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<path d="M15.27,10.41l1.05-1.05c.48-.48,1.15-.79,1.83-.73.88.08,1.78-.22,2.45-.89s.95-1.54.89-2.4l-.45-.45-1.39,1.39-1.7-.24-.24-1.7,1.39-1.39-.45-.45c-.86-.06-1.74.23-2.4.89s-.97,1.57-.89,2.45c.06.68-.25,1.35-.73,1.83l-1.33,1.33" />
		<path d="M9.01,13.31l-1.33,1.33c-.48.48-1.15.79-1.83.73-.88-.08-1.78.22-2.45.89s-.95,1.54-.89,2.4l.45.45,1.39-1.39,1.7.24.24,1.7-1.39,1.39.45.45c.86.06,1.74-.23,2.4-.89s.97-1.57.89-2.45c-.06-.68.25-1.35.73-1.83l1.05-1.05" />
		<g>
			<path d="M17.61,20.06c.63.63,1.64.78,2.36.26.92-.66.99-1.95.23-2.71l-6.78-6.77c-.48-.45-1.24-.44-1.71.03l-.77.77c-.47.47-.47,1.22-.03,1.71l6.7,6.72Z" />
			<polygon points="4.36 3.2 3.26 4.3 4.62 6.36 5.7 6.73 10.77 11.8 11.87 10.7 6.8 5.63 6.42 4.56 4.36 3.2" />
		</g>
	</svg>
);

const Link = () => (
	<svg className={css._} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<path d="M21.5,12.32v4.18c0,2.76-2.24,5-5,5H7.5c-2.76,0-5-2.24-5-5V7.5c0-2.76,2.24-5,5-5h4.18" />
		<line x1="14.86" y1="9.14" x2="20.04" y2="3.96" />
		<line x1="20.04" y1="7.46" x2="20.04" y2="3.96" />
		<line x1="16.54" y1="3.96" x2="20.04" y2="3.96" />
		<path d="M12.06,13.15c-.12.28-.29.55-.52.78h0c-.92.92-2.42.92-3.34,0l-2.31-2.31c-.92-.92-.92-2.42,0-3.34h0c.92-.92,2.42-.92,3.34,0l2.31,2.31" />
		<path d="M9.58,13.28c.12-.28.29-.55.52-.78h0c.92-.92,2.42-.92,3.34,0l2.31,2.31c.92.92.92,2.42,0,3.34h0c-.92.92-2.42.92-3.34,0l-2.31-2.31" />
	</svg>
);

export const MetaIcons = {
	Date,
	Role,
	Tool,
	Link,
};
